





































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'
import SpaceFields from '@ui/FormBuilder/ResourceFields/SpaceFields.coffee'

settings =
  name: 'SetupForm'

  vue:
    props: ['wizard', 'form', 'options', 'actions']

    components: {
      FormField,
    }

    data: ->
      priceInCents: {}

    computed:
      errors: -> {}

      fieldKeys: ->
        [
          'description'
          'images'
          'spaces'
        ]

      formFields: ->
        fields = {}
        fields[key] = @spaceFields.fields[key] for key in @fieldKeys
        fields

      contextForSpaceFields: ->
        _requiredFields: ['segment']
        options:
          spaces: { currentSpaceId: @$route.query.spaceId }
        inputProps:
          images:
            options: @options?.mediaKits
            tags: ['onsite_space']

      spaceFields: ->
        SpaceFields(@contextForSpaceFields)

      inputPropsForSegment: ->
        props = { ...@spaceFields.fields.segment.inputProps }
        props.disabled = @form.data.segment_renamed
        props

    methods:
      saveField: (fieldName) ->
        if @actions?.saveField
          @actions.saveField fieldName
        else
          @wizard.saveField fieldName

export default VueOptions.vue settings
